import { OrderItem, ORDER_ITEM_STATUS } from '@model/OrderItem';
import * as Yup from 'yup';
import { Delivery } from './Delivery';
import { ItemSpecificationModel, ItemSpecificationValidation } from './ItemSpecification';
import { Model } from './Model';
import { Collection } from './utils/Collection';

export const Item = Model<OrderItem>('Item', { endpoint: 'apparel-items' })`
    id:Int;
    name:String;
    notes:String;
    image_id:Int;
    image:Any;
    package_id:Int;
    package:Any;
    sku_id:Int;
    sku:Any;
    item_specifications:${Collection(ItemSpecificationModel)};
    spec_sizeable:boolean;
    spec_nameable:boolean;
    spec_numberable:boolean;
    documents:Any;
    document_ids:Any;
    quantity:Int;
    order_id:Int;
    delivery:${Delivery};
    shipping_details:Any;
    shipping_method_id:Int;
`;

export const ItemValidation = Yup.object({
    package_id: Yup.string().nullable(),
    selectable_sku_id: Yup.string().required('Selectable SKU is required'),
    notes: Yup.string().nullable(),
    item_specifications: Yup.array(ItemSpecificationValidation),
});

export const calculateItemQty = (specs) => (specs ?? []).reduce((sum, spec) => sum + parseInt(spec.quantity ?? 1), 0);

export const calculateDivisionItemQty = (specs = []) =>
    specs.reduce(
        (grandTotal, spec) =>
            grandTotal + (spec.item_specifications ?? []).reduce((sum, item) => sum + Number(item.quantity || 0), 0),
        0,
    );

export const itemIsCancelable = (orderItem: OrderItem) =>
    orderItem.status === ORDER_ITEM_STATUS.PENDING || orderItem.status === ORDER_ITEM_STATUS.UNSHIPPED;

export const itemSkuSizes = (item) =>
    (item.sku.sizing_ranges ?? []).reduce((acc, { sizes }) => {
        return [...acc, ...sizes];
    }, []);
